module.exports = __webpack_public_path__ + "static/img/iconfont.76a002d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/slider_font/iconfont.svg?t=1614911904219
// module id = +2Wo
// module chunks = 133